export default __webpack_public_path__ + "static/media/sanitizer1.0824dca0.jpg";